export default __webpack_public_path__ + "static/media/pouchdb.8e437354.svg";